import { AuthenticationManager } from '@frontend/authentication-v2';
import { ToastUtil } from '@frontend/toast-utils';
import { useEffect, useState } from 'react';
import { NavigateFunction, useLocation, useNavigate } from 'react-router-dom';

import { Props } from './basic-login.component';

interface ViewProps {
    submitted: boolean;
    formValues: FormResult;
    emailValid: boolean;
    passwordValid: boolean;
    keepLoggedIn: boolean;
    onSubmit: (e: any) => void;
    changeFormValues: React.Dispatch<React.SetStateAction<FormResult>>;
    changeEmailValid: React.Dispatch<React.SetStateAction<boolean>>;
    changePasswordValid: React.Dispatch<React.SetStateAction<boolean>>;
    changeKeepLoggedIn: React.Dispatch<React.SetStateAction<boolean>>;
    navigate: NavigateFunction;
}

interface FormResult {
    email: string;
    password: string;
}

const useBasicLogin = (props: Props): ViewProps => {
    const [submitted, changeSubmitted] = useState<boolean>(false);
    const [formValues, changeFormValues] = useState<FormResult>({ email: '', password: '' });
    const [emailValid, changeEmailValid] = useState<boolean>(true);
    const [passwordValid, changePasswordValid] = useState<boolean>(true);
    const [keepLoggedIn, changeKeepLoggedIn] = useState<boolean>(AuthenticationManager.getInstance().isKeepLoggedInEnabled());
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const stateAny = location.state;
        let initial: string | null = null;
        if (stateAny && stateAny.from) {
            const from = stateAny.from;
            const path = (from.pathname || '') + (from.search || '') + (from.hash || '');
            initial = path || null;
        }

        if (!initial) {
            const stored = sessionStorage.getItem('preLoginRedirect');
            if (stored) {
                initial = stored;
            } else {
                const current = location.pathname + location.search + location.hash;
                if (!/\/login/i.test(current)) {
                    initial = current;
                }
            }
        }

        if (initial) {
            if (!sessionStorage.getItem('preLoginRedirect')) {
                sessionStorage.setItem('preLoginRedirect', initial);
            }
        }
    }, []);
    const onSubmit = (e: any) => {
        e.preventDefault();
        if (emailValid && passwordValid) {
            changeSubmitted(true);
            AuthenticationManager.getInstance()
                .authenticate(formValues.email.toLowerCase(), formValues.password, keepLoggedIn)
                .then(() => {
                    props.callback && props.callback();
                    const redirectTo = sessionStorage.getItem('preLoginRedirect');
                    if (redirectTo) {
                        sessionStorage.removeItem('preLoginRedirect');
                        navigate(redirectTo);
                    }
                })
                .catch(() => {
                    ToastUtil.error('Your username or password is incorrect. Please correct and try again.');
                    changeSubmitted(false);
                });
        }
    };
    return {
        submitted,
        formValues,
        emailValid,
        passwordValid,
        keepLoggedIn,
        onSubmit,
        changeFormValues,
        changeEmailValid,
        changePasswordValid,
        changeKeepLoggedIn,
        navigate
    };
};

export default useBasicLogin;
